/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useState, useEffect } from 'react';
import "@9softstudio/react-monthpicker/dist/reactmonthpicker.css";
import 'moment/locale/es';
import { closelightbox } from "../../../util/Functions";
import * as API from '../../../http/api';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import * as FORMAT from 'react-day-picker/moment';
import { format } from "../../../util/DateUtil";
import { REGEX_EMAIL } from "../../../util/RegEx";

const ContraCargoDispta = (props) => {

    const [data, setData] = useState({});
    const [sectionOptions,setSectionOptions] = useState([
   
        {"id":"","input":false,"text":"Cardholder did not engage in nor authorize the transaction"},
        {"id":"","input":false,"text":"Cardholder does not recognize the non-face-to-face transaction appearing on his/her account (every effort was made to identify the transaction for the cardholder)"},
        {"id":"","input":false,"text":"Cardholder was in possession and control of the card issued at the time of the transaction."},
        {"id":"","input":false,"text":"Cardholder was not in possession nor in control of the card issued. The card used was lost or stolen."},
    ]);
    const [checks,setChecs] = useState([
        {
            "check": false
        },
        {
            "check": false
        },
        {
            "check": false
        },
        {
            "check": false
        },
    ])
    const [sectionA,setSectionA] = useState(true);
    const [textSectionA,setTextSectionA] = useState("");
    const [inputSectionA,setInputSectionA] = useState(false);
    const [msnDesc,setDesc] = useState("");
    const [disabled,setDisabled] = useState(true);
    const [dateDesc,setDateDesc] = useState("");
    const [startDate, setStartDate] = useState(new Date());
    const [name,setName] = useState("");
    const [phone,setPhone] = useState("");
    const [populationId,setPopulationID] = useState("");
    const [email,setEmail] = useState("");
    var   [emailSend,setEmailSend] = useState("");
    const [emailDisable,setEmailDisable] = useState(false)
    const [disabledEnvio,setDisabledEnvio] = useState(true);
    const [sendEmail, setSendEmail] = useState(false);

    useEffect(() => {
        setData(props.data);
        if (props.config["actions"].indexOf("sendEmail") > -1) {
          setSendEmail(true);
        }
        init();
    }, [])

    const init  = async ()=>{
        setName(props.customer.name);
        setEmail(props.customer.email);
        setPopulationID(props.customer.populationid);
        setPhone(props.customer.phone);   
    }

    const handleSectionOption = (event)=>{
        let value = event.target.value;
        let aux;
        sectionOptions.map((data, index) => {
            if(data.text === value){
                aux = data;
                setInputSectionA(aux.input)
                setSectionA(false)
                setTextSectionA(value)
                checks[index].check = true;
                setDisabled(false)
            }  
        })
    }

    const resetSection = () =>{
        setSectionA(true);
        setInputSectionA(false)
        setDisabled(true)
    }

    const formatDate = (date)=>{
        return format(date);
    }

    const descarga = async ()=>{
        props.changeLoader(true);

        if(textSectionA.trim().length === 0){
            props.changeLoader(false);
            return;
        }
    
        var data = {
            "type": "fraude-ttk",
            "content": {
                "transactInformation": {
                    "serialNumber": props.data.tracking_key,
                    "merchantName": props.data.concept,
                    "transactDate": formatDate(props.data.cdate),
                    "transactAmount": props.data.amount.toString(),
                    "disputedAmount": props.data.amount.toString(),
                    "cardholderName":name,
                    "date":formatDate(startDate),
                    "identityNumber": populationId,
                    "contactNumber": phone,
                    "email":email,
                    "wallet": props.data.walletID,
                    "cardNumber": "",
                },
                "secA": {
                    "checks": checks,
                    "participation": true,
                    "description": msnDesc
                }
            },
            "url": "signed",
            "agent_uuid": JSON.parse(localStorage.session).uuid,
        }

        let request = await API.service('cartasDocs', data, props.pos, props.changeAlert, props.changeLoader, props.history);

        if(request.status === 200){
            if(request.data.data.response === "OK"){
                var dataResult = request.data.data.widget[0].content.url;
                props.changeAlert(true, 'success', 'Carta de contra cargos creada con éxito');
                window.open(dataResult, '_blank');
            }else{
                props.changeAlert(true, 'error', 'Error al crear la carta de contra cargos.');
            }
        }

        closelightbox();
        props.changeLoader(false);
        
    }



    const enviar = async ()=>{
        props.changeLoader(true);

        if(textSectionA.trim().length === 0){
            props.changeLoader(false);
            return;
        }

        var data = {
            "type": "fraude-ttk",
            "content": {
                "transactInformation": {
                    "serialNumber": props.data.tracking_key,
                    "merchantName": props.data.concept,
                    "transactDate": props.data.cdate,
                    "transactAmount": props.data.remote_account?.authorization_number,
                    "disputedAmount": props.data.amount.toString(),
                    "cardholderName":name,
                    "date":formatDate(startDate),
                    "identityNumber": populationId,
                    "contactNumber": phone,
                    "email":email,
                    "wallet": props.data.walletID,
                    "cardNumber": props.data.card.pan_masked,
                },
                "secA": {
                    "checks": checks,
                    "participation": true,
                    "description": msnDesc
                }
            },
            "url": "signed",
            "agent_uuid": JSON.parse(localStorage.session).uuid,
        }

        let request = await API.service('cartasDocs', data, props.pos, props.changeAlert, props.changeLoader, props.history);

        if(request.status === 200){
            if(request.data.data.response === "OK"){
                var url = request.data.data.widget[0].content.url;

                if(!REGEX_EMAIL.test(emailSend)){   
                    emailSend = email;
                }
                 var dataSend ={
                    url:url,
                    email: emailSend,
                    docName: "Disputa internacional",
                    name:name
                }
                var requestSend = await API.service('cartasDocsSend', dataSend, props.pos, props.changeAlert, props.changeLoader, props.history);

                if(requestSend.status == 200 && requestSend.data.data.response === "OK"){
                    props.changeAlert(true, 'success', 'Carta de contra cargos enviada con éxito');
                }else{
                    props.changeAlert(true, 'error', 'Error al enviar la carta de contra cargos.');
                }
            }else{
                props.changeAlert(true, 'error', 'Error al enviar la carta de contra cargos.');
            }
        }
        closelightbox();
        props.changeLoader(false);
    }

    const resetChecks = ()=>{
        checks.map(data=>{
            data.check = false;
        })
    }

    const changeDateDesc = (event)=>{ 
        var value = event.toJSON().substring(0, 10);
        setDateDesc(value)
        setDisabled(false)
    }

    const editEmail = ()=>{
        if(emailDisable){
            setEmailDisable(false);
            setDisabledEnvio(false)
        }else{
            setEmailDisable(true);
            setDisabledEnvio(true)
        }
    }

    const newEmailSend = (event) =>{
        var value = event.target.value;
        if ( !REGEX_EMAIL.test(value)) {
            setDisabledEnvio(true)
            setEmailSend(email)
            return;
        } else {
            setDisabledEnvio(false)
            setEmailSend(value);
        }   
    }


    return (<div className="card carta-doc">
        <div className="text-right modal_header_close">
            {
              <div
                className="tooltip"
                style={{ marginRight: "10px", cursor: "pointer" }}
              >
                <span className="tooltiptext tooltip-bottom">Descargar</span>
                <i className="ibon-download" onClick={descarga} ></i>
              </div>
            }

            <div className="tooltip">
              <span className="tooltiptext tooltip-bottom">Cerrar</span>
              <i className="ibon-close tap" onClick={closelightbox}></i>
            </div>
        </div>
        <h3 className="modal_header_title">Fraude</h3>
        
        <div className="">
            <div className="carta-header">
                <h2>Dispute Resolution Form - FRAUD </h2>
            </div>

            <div className="carta-form">
                <div className="carta-form-personal">
                    <h3>Transaction Information:</h3>
        
                    <br />
                 
                    <div className="card-form-personal-data">
                        <div className="card-form-data-flex">
                            <p><span>Merchant Name:</span> {props.data.concept}</p>
                            <p><span>Transaction Amount:</span> {props.data.remote_account?.authorization_number}</p>
                        </div>

                        <div className="card-form-data-flex">
                            <p><span>Transaction or Settlement Date:</span>{formatDate(props.data.cdate)}</p>
                            <p><span>Disputed Amount:</span> {props.data.amountFormated}</p>
                        </div>
                    </div>
                    <h4>Cardholder details:</h4>

                    <div className="card-form-personal-data">
                        <div className="card-form-data-flex">
                            <p><span>Cardholder full name:</span> {name}</p>
                            <p><span>Contact number:</span> {phone} </p>
                            <p><span>Wallet ID:</span>{props.data.walletID} </p>
                        </div>

                        <div className="card-form-data-flex">
                            <p><span>Identity number:</span> {populationId}</p>
                            <p><span>Email address:</span>{email}</p>
                            <p><span>Card Number:</span>{props.data.card.pan_masked}</p>
                        </div>
                    </div>
                </div>

                <div className="carta-form-section">
                    <h3>Type of Fraud Dispute (check all applicable):</h3>
                    <h3>Cardholder Dispute Chargeback</h3>
                    <h4>Type of Cardholder Dispute:</h4>
                    <ul style={{marginTop: 5}}>
                        {sectionOptions.map((data, i) => {
                            return (
                            <li key={i}>
                                <input style={{marginTop: 4, marginRight: 10}} type="checkbox" onChange={handleSectionOption.bind(this)} value={data.text} />
                                <span> 
                                    {data.text} 
                                    {data.input &&
                                        <input type="text" className="card-form-input"/>
                                    }
                                </span>
                            </li>)
                        })
                        }
                    </ul>
                </div>
            
                <div className="carta-form-section">
                    <h2>Dispute Details</h2>

                    <p>Describe the cardholder’s compliant in sufficient detail to meet the requirements for the chargeback as described in the chargeback guide and to enable all parties to understand the dispute</p>
                    <span className="card-reset">Llenar solamente en ingles</span>
                    <textarea  onChange={(e)=>{setDesc(e.target.value)}}  className="carta-textarea"></textarea>
                    <p>
                        Date
                        <DayPickerInput
                            style={{height: '30px', width: '25%',margin:'0 10px'}}
                            onDayChange={changeDateDesc}
                            placeholder='Select the date'
                            format="DD-MM-YYYY"
                            value={startDate}
                            inputProps={{
                                readOnly: true
                            }}
                            formatDate={FORMAT.default.formatDate}
                            parseDate={FORMAT.default.parseDate}
                            dayPickerProps={{
                                months: ["Ene", "Feb", "Mar","Abr", "May", "Jun","Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
                                pagedNavigation: true,
                                numberOfMonths: 1,
                            }}
                        />
                    </p>
                    {sendEmail &&
                        <div className="envioCartaEmail">
                            <p>Ingresar nuevo email <i className="tap ibon-chevron-down" onClick={editEmail}></i>  </p>
                            {emailDisable &&
                                <input type="text"  style={{width:"50%"}} placeholder="Email..." className="ibon-account" onChange={newEmailSend.bind(this)} />
                            }

                            {emailDisable &&
                                <p>Se enviará a {emailSend}, {name} </p>
                            }

                            {!emailDisable &&
                                <p>Se enviará a {email}, {name}</p> 
                            }

                            <div style={{marginRight:"60px"}} className="carta-footer-col-3">
                                {
                                    <div className={ disabled ? 'disable bigButton  pnl-btn-save  pos-left' : 'bigButton pnl-btn-save  pos-left'}>
                                        <button  type="submit" onClick={enviar}>Enviar</button>
                                    </div>
                                }
                                
                            </div>
                        </div>
                    }
                </div>



                <div className="carta-form-section">
                    <div className="carta-footer">
                        <div className="carta-footer-col">
                            <div className="bigButton pos-left">
                                <button onClick={closelightbox} >Cancelar</button>
                            </div>
                        </div>
                        <div className="carta-footer-col-3">
                            <div className={disabled ? 'disable bigButton pos-right pnl-btn-save' : 'bigButton pos-right pnl-btn-save'}>
                                <button disabled={disabled} type="submit" onClick={descarga}>Descargar</button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>)
}

export default ContraCargoDispta;